"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.refreshToken = exports.callAPI = exports.callAPIv2 = exports.BASE_API_URL = exports.getLiveCMSBaseURL = exports.BASE_URL = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _humps = require("humps");

var _helpers = require("../helpers");

var _index = require("../../index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function getBaseURL() {
  switch (process.env.REACT_APP_RM_ENV) {
    case 'prod':
      return 'https://livecms.roymorgan.com';

    case 'uat':
      return 'https://livecms.roymorganuat.com';

    default:
      return 'https://livecms.roymorgandev.com';
  }
} // Set BASE_URL via environment variable


var BASE_URL = getBaseURL();
exports.BASE_URL = BASE_URL;

var getLiveCMSBaseURL = function getLiveCMSBaseURL() {
  var namespace = (0, _helpers.getLiveCMSEndpointURI)();
  return BASE_URL + "/wp-json/" + namespace;
};

exports.getLiveCMSBaseURL = getLiveCMSBaseURL;
var BASE_API_URL = (0, _index.getApiEndpoint)(process.env.REACT_APP_RM_ENV);
exports.BASE_API_URL = BASE_API_URL;

/*
 * DO NOT MODIFY THIS METHOD
 *
 * API logic should not live inside this method
 * unless it's going to be used across multiple API calls.
 *
 * Please speak to Sean Gilmore if you have issues with this.
 */
var callAPIv2 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var method, targetUrl, token, headers, body, fullHeaders, response, errorResponse, error, json;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            method = _ref.method, targetUrl = _ref.targetUrl, token = _ref.token, headers = _ref.headers, body = _ref.body;
            fullHeaders = token ? new Headers(_extends({
              'Content-Type': 'application/json'
            }, headers, {
              token: token
            })) : new Headers(_extends({
              'Content-Type': 'application/json'
            }, headers)); // $FlowFixMe

            _context.next = 4;
            return fetch(targetUrl, {
              method: method,
              headers: fullHeaders,
              body: JSON.stringify(body)
            });

          case 4:
            response = _context.sent;

            if (response.ok) {
              _context.next = 12;
              break;
            }

            _context.next = 8;
            return response.json();

          case 8:
            errorResponse = _context.sent;
            error = Error('Invalid API Response');
            error.msg = errorResponse.errors ? errorResponse.errors[0].message : errorResponse.statusMessage ? errorResponse.statusMessage : 'API Error';
            throw error;

          case 12:
            _context.next = 14;
            return response.json();

          case 14:
            json = _context.sent;
            return _context.abrupt("return", json);

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function callAPIv2(_x) {
    return _ref2.apply(this, arguments);
  };
}(); // WARNING: Stop using this method and start using callAPIv2


exports.callAPIv2 = callAPIv2;

var callAPI = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref3) {
    var method, endpoint, body, isLiveAPICall, useToken, selfRegisteredToken, customHeaders, targetUrl, activeToken, token, tempHeaders, _i, _Object$entries, _Object$entries$_i, k, v, headers, response, errorResponse, error, json, camelizedJson;

    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            method = _ref3.method, endpoint = _ref3.endpoint, body = _ref3.body, isLiveAPICall = _ref3.isLiveAPICall, useToken = _ref3.useToken, selfRegisteredToken = _ref3.selfRegisteredToken, customHeaders = _ref3.customHeaders;
            _context2.prev = 1;
            targetUrl = isLiveAPICall ? "" + endpoint : "" + BASE_URL + endpoint;

            if (isLiveAPICall === true && useToken === true) {
              activeToken = (0, _index.getAuthToken)();
            }

            token = selfRegisteredToken ? selfRegisteredToken : activeToken;
            tempHeaders = !(typeof token === 'undefined') && token && isLiveAPICall === true ? new Headers({
              'Cache-Control': 'no-cache',
              'Content-Type': 'application/json',
              token: token
            }) : null;
            tempHeaders = typeof token === 'undefined' && isLiveAPICall === true ? new Headers({
              'Content-Type': 'application/json'
            }) : tempHeaders;

            if (customHeaders && tempHeaders) {
              // loop over the customHeaders and append
              for (_i = 0, _Object$entries = Object.entries(customHeaders); _i < _Object$entries.length; _i++) {
                _Object$entries$_i = _Object$entries[_i], k = _Object$entries$_i[0], v = _Object$entries$_i[1];
                // $FlowFixMe
                tempHeaders.append(k, v);
              }
            }

            headers = tempHeaders;

            if (!(headers === null)) {
              _context2.next = 15;
              break;
            }

            _context2.next = 12;
            return fetch(targetUrl, {
              method: method,
              body: JSON.stringify(body)
            });

          case 12:
            _context2.t0 = _context2.sent;
            _context2.next = 18;
            break;

          case 15:
            _context2.next = 17;
            return fetch(targetUrl, {
              method: method,
              headers: headers,
              body: JSON.stringify(body)
            });

          case 17:
            _context2.t0 = _context2.sent;

          case 18:
            response = _context2.t0;

            if (response.ok) {
              _context2.next = 27;
              break;
            }

            _context2.next = 22;
            return response.json();

          case 22:
            errorResponse = _context2.sent;
            error = Error('API Error');

            if (errorResponse.errors) {
              error.message = errorResponse.errors[0].message;
            } else if (errorResponse.message) {
              error.message = errorResponse.message;
            }

            error.code = 'API';
            throw error;

          case 27:
            _context2.next = 29;
            return response.json();

          case 29:
            json = _context2.sent;
            camelizedJson = (0, _humps.camelizeKeys)(json, _helpers.noCamelize);
            return _context2.abrupt("return", camelizedJson);

          case 34:
            _context2.prev = 34;
            _context2.t1 = _context2["catch"](1);
            console.error(_context2.t1);

            if (!(_context2.t1.code === 'API')) {
              _context2.next = 39;
              break;
            }

            throw _context2.t1;

          case 39:
            throw new Error('API Error');

          case 40:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 34]]);
  }));

  return function callAPI(_x2) {
    return _ref4.apply(this, arguments);
  };
}();

exports.callAPI = callAPI;

var refreshToken = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee3(dispatch) {
    var result;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!(process.env.NODE_ENV !== 'test')) {
              _context3.next = 5;
              break;
            }

            _context3.next = 3;
            return dispatch((0, _index.refreshToken)());

          case 3:
            result = _context3.sent;

            if (!result) {
              dispatch((0, _index.logOut)());
              window.location.href = '/login';
            }

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function refreshToken(_x3) {
    return _ref5.apply(this, arguments);
  };
}();

exports.refreshToken = refreshToken;